export default __webpack_public_path__ + "static/media/btn-app-store.9e5ae6b7.png";